module.exports = __webpack_public_path__ + "img/sushi-king-menu-06.3e43f524.png";